import { Route, Routes } from "react-router-dom";
import Layout from "./components/layout";
import { routes } from "./routes";

const Router = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        {routes.map((route) => {
          return (
            <Route key={route.path} path={route.path} element={route.element} />
          );
        })}
      </Route>
      <Route path={"*"} element={<div>not Found!!!</div>} />
    </Routes>
  );
};

export default Router;
